interface BalanceCardProps {
  title: string;
  amount: number;
  currency?: string;
  className?: string;
}

export function BalanceCard({ title, amount, currency = 'USD', className = '' }: BalanceCardProps) {

  return (
    <div className={`bg-neutral-dark/30 rounded-lg p-4 md:p-6 transition-all duration-300 hover:bg-neutral-dark/40 hover:scale-105 ${className}`}>
      <label className="block text-sm font-medium text-neutral-medium mb-2 font-body">
        {title}
      </label>
      <p className="text-2xl md:text-3xl font-bold text-brand-accent font-heading">
        {amount.toFixed(2)} {currency}
      </p>
    </div>
  );
}

